import styled from "styled-components";

export const ScheduleToolbarStyles = styled.div`
  padding: 12px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary[100]};
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: ${({ theme }) => theme.colors.semantic.container.white};

  .date-group {
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.primary[100]};
    border-radius: 8px;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.semantic.background.white};

    button {
      border: none;
      background: transparent;
      padding: 8px 10px;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.primary[600]};
      display: grid;
      place-items: center;
      font-family: inherit;

      &:hover {
        background: ${({ theme }) => theme.colors.primary[50]};
      }
    }

    .date-label {
      padding: 0 12px;
      font-size: 13px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }
  }

  .today-btn {
    padding: 7px 12px;
    border: 1px solid ${({ theme }) => theme.colors.primary[100]};
    border-radius: 8px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary[600]};
    font-weight: 500;
    background: ${({ theme }) => theme.colors.semantic.background.white};
    cursor: pointer;
    font-family: inherit;

    &:hover {
      background: ${({ theme }) => theme.colors.primary[50]};
    }
  }

  .divider {
    width: 1px;
    height: 22px;
    background: ${({ theme }) => theme.colors.primary[100]};
  }

  .show-label {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.primary[400]};
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-right: -4px;
  }

  .chips {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px 5px 8px;
    border-radius: 999px;
    border: 1px solid ${({ theme }) => theme.colors.primary[100]};
    background: ${({ theme }) => theme.colors.semantic.background.white};
    color: ${({ theme }) => theme.colors.primary[400]};
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;

    .dot {
      width: 7px;
      height: 7px;
      border-radius: 999px;
      background: ${({ theme }) => theme.colors.primary[200]};
    }

    .count {
      opacity: 0.7;
      font-variant-numeric: tabular-nums;
    }

    &.on {
      border-color: var(--chip-border);
      background: var(--chip-bg);
      color: var(--chip-fg);

      .dot {
        background: var(--chip-color);
      }
    }
  }

  .spacer {
    flex: 1;
  }

  .unassigned-btn {
    padding: 7px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-family: inherit;
    background: ${({ theme }) => theme.colors.semantic.background.white};
    color: ${({ theme }) => theme.colors.primary[600]};
    border: 1px solid ${({ theme }) => theme.colors.primary[100]};

    .badge {
      background: ${({ theme }) => theme.colors.primary[200]};
      color: ${({ theme }) => theme.colors.semantic.background.white};
      font-size: 10px;
      font-weight: 600;
      padding: 1px 6px;
      border-radius: 999px;
    }

    &.on {
      background: ${({ theme }) => theme.colors.accent[50]};
      color: ${({ theme }) => theme.colors.accent[600]};
      border-color: ${({ theme }) => theme.colors.accent[150]};

      .badge {
        background: ${({ theme }) => theme.colors.accent[500]};
      }
    }
  }
`;
